export default "__VITE_ASSET__42f0dae3__"